import script from "./AidSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AidSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./AidSearchBar.vue?vue&type=style&index=0&id=ffe1bb3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffe1bb3a"]])

export default __exports__